module.exports = __webpack_public_path__ + "static/media/medicamentos.c5ec21df.svg";